import { selectWebSites } from '@newStore/externalData/externalDataSelectors';
import type { EditAsideWebOldUrls } from '@nodeTypeConfig/configTypes';
import { updateWebsiteConfigurationActionNew } from '@store/actions/documentActions';
import { addNotificationAction } from '@store/actions/notificationActions';
import { getOldLocation } from '@store/helpers/webConfigHelpers';
import { get } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import { useCurrentWebConfig } from '../../../hooks/UseCurrentWebConfig';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useTypedSelector } from '../../../hooks/useTypedSelector';

const AsideWebOldUrls: React.FC<{
  config: EditAsideWebOldUrls;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();
  const editHref = useEditHref();
  const currentWebConfig = useCurrentWebConfig();

  const initialValue = get(currentWebConfig, config.property, '');
  const webSites = useTypedSelector(selectWebSites);
  const selectedOptions = initialValue
    ? initialValue?.map((value) => {
        const url = `https://${webSites[value.website.href].domain}${value.path}`;
        return { label: url, value: url };
      })
    : [];

  const change = (allOptions, action) => {
    const validWebsites = Object.values(webSites).map((site) => `https://${site.domain}`);
    if (
      action.option &&
      !Object.values(validWebsites).some((site) =>
        action.option.value.toLowerCase().startsWith(site),
      )
    ) {
      dispatch(
        addNotificationAction({
          type: 'ERROR',
          message: `Vorige url's: ongeldige website. Kies uit : ${validWebsites.join(', ')}.`,
        }),
      );
    } else {
      dispatch(
        updateWebsiteConfigurationActionNew(
          editHref,
          config.property,
          allOptions.map((o) => getOldLocation(o.value.toLowerCase(), Object.values(webSites))),
        ),
      );
    }
  };

  return (
    <div>
      <label className="control-label">{config.label}</label>
      <CreatableSelect isMulti value={selectedOptions} onChange={change} isDisabled={readonly} />
    </div>
  );
};

AsideWebOldUrls.displayName = 'AsideWebOldUrls';

export default AsideWebOldUrls;

AsideWebOldUrls.propTypes = {
  config: any,
  readonly: any,
};
